import 'babel-polyfill' //ie空白
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router' //导入路由
import ElementUI from 'element-ui' //导入ele-ui
import store from './store/store' //导入vuex状态管理器
import Viewer from 'v-viewer' //导入图片预览
import Utils from './utils/utils' //导入公用方法
import Api from './api/api' //导入api接口
import Axios from './request/http' //导入axios请求
import Config from '../config/config' //后台返回状态码

// import Print from './components/print/print.js';
// Vue.use(Print);
import Print from 'vue-print-nb'
Vue.use(Print);
//引入Viewer基础样式
import 'viewerjs/dist/viewer.css'
import 'element-ui/lib/theme-chalk/index.css'
//引入基础样式
import './assets/base/base.css'
import './assets/less/index.less'

//引入iconfont字体
import './icons/iconfont/iconfont.css'
import './icons/iconfont/iconfont.eot'
import './icons/iconfont/iconfont.ttf'
import './icons/iconfont/iconfont.svg'

//引入ueditor富文本
import '../static/UE/ueditor.config.js'
import '../static/UE/ueditor.all.js'
import '../static/UE/lang/zh-cn/zh-cn.js'
import '../static/UE/ueditor.parse.min.js'
//使用Use中间件使用插件
//使用ElementUI
Vue.use(ElementUI);
//使用Viewer
Vue.use(Viewer);
//使用公共方法
Vue.use(Utils);
//在vue上挂载api
Vue.prototype.$api = Api; //在vue上挂载api
Vue.prototype.$axios = Axios;
Vue.prototype.$config = Config; //配置信息

//lodash
import _ from 'lodash';
Vue.prototype._ = _;
//全局图片放大预览Viewer配置，如果弹出前后要操作则可放开
/*Viewer.setDefaults({
	'inline':false,
	'button':true, //右上角按钮
	"navbar": true, //底部缩略图
	"title": true, //当前图片标题
	"toolbar": true, //底部工具栏
	"tooltip": true, //显示缩放百分比
	"movable": true, //是否可以移动
	"zoomable": true, //是否可以缩放
	"rotatable": true, //是否可旋转
	"scalable": true, //是否可翻转
	"transition": true, //使用 CSS3 过度
	"fullscreen": true, //播放时是否全屏
	"keyboard": true, //是否支持键盘
	"url": "data-source",
	ready: function (e) {
	  console.log(e.type,'组件以初始化');
	},
	show: function (e) {
	  console.log(e.type,'图片显示开始');
	},
	shown: function (e) {
	  console.log(e.type,'图片显示结束');
	},
	hide: function (e) {
	  console.log(e.type,'图片隐藏完成');
	},
	hidden: function (e) {
	  console.log(e.type,'图片隐藏结束');
	},
	view: function (e) {
	  console.log(e.type,'视图开始');
	},
	viewed: function (e) {
	  console.log(e.type,'视图结束');
	},
	zoom: function (e) {
	  console.log(e.type,'图片缩放开始');
	},
	zoomed: function (e) {
		console.log(e.type,'图片缩放结束');
	}
});*/

//设置为 false 以阻止 vue 在启动时生成生产提示
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js